import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Calculator, UserPlus, FileEdit, LineChart, Box, RefreshCw, Printer, RotateCcw } from 'lucide-react';

const featureList = [
  { name: 'Conciliação automática de cartões', icon: <Calculator className="w-5 h-5" /> },
  { name: 'Controle de taxas de operadoras', icon: <LineChart className="w-5 h-5" /> },
  { name: 'Baixa automática de contas a receber', icon: <RefreshCw className="w-5 h-5" /> },
  { name: 'Auditoria de vendas em tempo real', icon: <CheckCircle2 className="w-5 h-5" /> },
  { name: 'Conferência de extratos bancários', icon: <FileEdit className="w-5 h-5" /> },
  { name: 'Identificação de erros de tarifação', icon: <Box className="w-5 h-5" /> },
  { name: 'Relatórios de fluxo de caixa projetado', icon: <Calculator className="w-5 h-5" /> },
  { name: 'Integração direta com bancos e adquirentes', icon: <RefreshCw className="w-5 h-5" /> }
];

export default function OlistFeatureSplitList() {
  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="grid grid-cols-1 sm:grid-cols-2 items-center gap-16 lg:gap-24">
          
          {/* Left Side: Mockup/Image */}
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="flex-1 w-full relative"
          >
            <div className="relative rounded-[3rem] overflow-hidden shadow-2xl bg-white border border-slate-100 p-4 group">
              <img 
                src="/showcase_conciliacao.png" 
                alt="Conciliação Bancária Lukos"
                className="rounded-[2.5rem] w-full shadow-inner"
              />
              
              {/* Decorative Corner Border (Bottom-Left) */}
              <div className="absolute bottom-0 left-0 w-32 h-32 border-b-8 border-l-8 border-[#7f00ff] rounded-bl-[3rem] -z-10 translate-x-3 translate-y-3 opacity-20" />
              <div className="absolute bottom-3 left-3 w-24 h-24 border-b-4 border-l-4 border-[#7f00ff] rounded-bl-[2.5rem] z-20 pointer-events-none" />

              {/* Floating element purely decorative or based on screenshot */}
              <div className="absolute top-10 -right-8 bg-white/95 backdrop-blur-sm p-6 rounded-3xl shadow-2xl border border-slate-100 hidden md:block">
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 bg-emerald-500 rounded-full animate-pulse" />
                  <span className="text-sm font-bold text-slate-800">Conciliação: 100% Concluída</span>
                </div>
              </div>
            </div>
            
            {/* Background blob */}
            <div className="absolute -bottom-16 -left-16 w-64 h-64 bg-purple-100/50 rounded-full blur-3xl -z-10" />
          </motion.div>

          {/* Right Side: Features */}
          <div className="flex-1 text-center sm:text-left">
            <motion.h2 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-4xl md:text-5xl font-semibold text-slate-900 mb-8 tracking-tight leading-tight"
            >
              Gestão financeira completa com <br/> 
              <span className="text-[#7f00ff]">conciliação automática</span>
            </motion.h2>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-10 mb-12">
              {featureList.map((feature, idx) => (
                <motion.div 
                  key={idx}
                  initial={{ opacity: 0, y: 15 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: idx * 0.05 }}
                  className="flex items-center gap-4 group"
                >
                  <div className="flex-shrink-0 w-12 h-12 rounded-2xl bg-purple-50 flex items-center justify-center text-[#7f00ff] group-hover:bg-purple-100 transition-colors">
                    {feature.icon}
                  </div>
                  <span className="text-slate-700 font-semibold leading-tight group-hover:text-[#7f00ff] transition-colors">
                    {feature.name}
                  </span>
                </motion.div>
              ))}
            </div>

            <motion.button 
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-[#7f00ff] text-white px-10 py-5 rounded-full font-bold text-lg hover:bg-[#5b21b6] transition-all shadow-xl shadow-purple-600/30"
            >
              30 dias grátis
            </motion.button>
          </div>
        </div>
      </div>
    </section>
  );
}
